import FeatShield from "../assets/featureSheild.png"
import FeatMagnifier from "../assets/featuremagnifier.png"
import FeatNutrients from "../assets/featureneutriant.png"
import FeatBooster from "../assets/featurebooster.png"
import FeatGurantee from "../assets/featuregurantee.png"
import FeatBreathing from "../assets/featurebreathing.png"
import Img1 from "../assets/image 22.png"
import Img2 from "../assets/magnesium-bhb.jpg.png"
import Img3 from "../assets/sodium-bhb.jpg.png"
import Bottle2 from "../assets/updated-2.png"
import Bottle3 from "../assets/updated-3.png"
import Bottle6 from "../assets/updated-6.png"
import Fda from "../assets/Figure → fda.png.png"
import Gmo from "../assets/Figure → gmo.png.png"
import Gmp from "../assets/Figure → gmp.png.png"
import Nat from "../assets/Figure → nat.png.png"
import Usa from "../assets/Figure → usa.png.png"


export const features = [
    {
        icon: FeatShield,
        title: 'Sinus Relief',
        description: 'Experience fast, natural relief from sinus congestion and pressure'
    },
    {
        icon: FeatMagnifier,
        title: 'Fast Clearance Solutions',
        description: 'Rapid and effective clearance of sinus blockages'
    },
    {
        icon: FeatNutrients,
        title: 'Natural Ingredients',
        description: 'Best-in-class bioactive ingredients, scientifically proven'
    },
    {
        icon: FeatBooster,
        title: 'Immune Boosting',
        description: 'Strengthen your body\'s defenses and protect against allergens and irritants'
    },
    {
        icon: FeatGurantee,
        title: 'Satisfaction Guaranteed',
        description: 'Risk-free trial with 90-day money back guarantee for your peace of mind'
    },
    {
        icon: FeatBreathing,
        title: 'Effortless Breathing',
        description: 'Breathe freely again with Sinoclear\'s proven formula'
    }
];

export const ScienceBackdata = [
    {
        id: 1,
        imageSrc: Img2,
        alt: 'Groundbreaking Research',
        title: 'Groundbreaking Research',
        description: 'Backed by extensive clinical studies and scientific research',
    },
    {
        id: 2,
        imageSrc: Img1,
        alt: 'Clinically-Proven Ingredients',
        title: 'Clinically-Proven Ingredients',
        description: 'Carefully selected ingredients for maximum effectiveness',
    },
    {
        id: 3,
        imageSrc: Img3,
        alt: 'Doctor-Recommended Solution',
        title: 'Doctor-Recommended Solution',
        description: 'Trusted and recommended by healthcare professionals',
    },
];

export const plans = [
    {
        img: Bottle2,
        title: '2 Bottles',
        subtitle: '60 Day Supply',
        leastpopular:true,
        price: 69,
        buttonText: 'BUY NOW',
        buttonColor: 'bg-yellow-400',
        url: "https://buygoods.com/secure/checkout.html?account_id=10398&product_codename=sin2&redirect=aHR0cHM6Ly9zaW5vY2xlYXIubmV0L3UxLw==&subid=[cmc_vid]&vid1=v1",

        popular: false,
        shipping: '9.99',
        discount: " You Save $220",
        gurantee: " 180 DAYS GUARANTEE",
        buttonTextType: 'Basic Offer',
        old_price: "358",
        new_price: "138"
    },
    {
        img: Bottle6,
        title: '6 Bottles',
        subtitle: '180 Day Supply',
        price: 39,
        buttonText: 'BUY NOW',
        buttonColor: 'bg-orange-500',
        url: "https://buygoods.com/secure/checkout.html?account_id=10398&product_codename=sin6&redirect=aHR0cHM6Ly9zaW5vY2xlYXIubmV0L3UxLw==&subid=[cmc_vid]&vid1=v1",
        leastpopular:false,
        popular: true,
        shipping: 'free',
        discount: ' YOU SAVE $840',
        biggestdisc: ' BIGGEST DISCOUNT',
        gurantee: '180 DAYS GUARANTEE',
        buttonTextType: 'Best Offer',
        old_price: "1074",
        new_price: "234"

    },
    {
        img: Bottle3,
        title: '3 Bottles',
        subtitle: '90 Day Supply',
        price: 59,
        features: ['90-DAY SUPPLY'],
        buttonText: 'BUY NOW',
        url: "https://buygoods.com/secure/checkout.html?account_id=10398&product_codename=sin3&redirect=aHR0cHM6Ly9zaW5vY2xlYXIubmV0L3UxLw==&subid=[cmc_vid]&vid1=v1",
        leastpopular:false,
        buttonColor: 'bg-yellow-400',
        popular: false,
        shipping: 'free',
        discount: "  YOU SAVE $360",
        gurantee: '180 DAYS GUARANTEE',
        buttonTextType: 'Good Offer',
        old_price: "537",
        new_price: "177"



    }
];

export const faqsData = [
    {
        question: "Is SinoClear right for me?",
        answer: "Every person is different, but SinoClear® is remarkably effective for nearly everyone who's tried it. It contains well-studied ingredients with tons of evidence showing their efficacy. If for any reason you're not satisfied with SinoClear®, you can return it and receive 100% of your investment back."
    },
    {
        question: "Is SinoClear safe?",
        answer: "SinoClear® is a natural proprietary formula manufactured in the USA at our FDA registered and GMP certified facility using state-of-the-art, precision-engineered machinery under the strictest and most sterile standards. Each ingredient is 100% natural, soy-free, dairy-free, non-GMO, and undergoes third-party inspections to ensure high purity and potency. We recommend showing a bottle to your doctor before use. Results may vary, with most users seeing improvement in 3-6 months. For best results, a 3 or 6 bottle package is recommended. A 180-day money-back guarantee is available for your most recent order."
    },
    {
        question: "What is the best way to take SinoClear?",
        answer: "Take 2 capsules daily with 6-8oz of water after a meal, or as directed by a healthcare professional."
    },
    {
        question: "Is this a one-time payment with no auto-ship, subscription, or hidden charges?",
        answer: "Yes, your order is a one-time payment with no auto-ship, subscriptions, or hidden charges."
    },
    {
        question: "What if SinoClear® doesn’t work for me?",
        answer: "Every bottle of SinoClear® comes with a 180-day 100% money-back guarantee. If you’re unsatisfied with your results, return the bottles for a full refund, minus shipping and handling."
    },
    {
        question: "What do I do now?",
        answer: "Click on one of the packages below, enter your order details on the secure checkout page, and your SinoClear® will be shipped out to you straight away."
    }
    
];

export const referencesData = [
    "https://phys.org/news/2007-05-radiation-eating-fungi.html#google_vignette",
    "https://pubmed.ncbi.nlm.nih.gov/12452574/",
    "https://www.ncbi.nlm.nih.gov/pubmed/9932596",
    "https://jamanetwork.com/journals/jamaotolaryngology/fullarticle/509953",
    "https://www.ncbi.nlm.nih.gov/pubmed/25339490",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4443571/",
    "https://jjmd.com/detox-from-mold-glutathione-mother-of-all-antioxidants/",
    "https://www.ncbi.nlm.nih.gov/labs/pmc/articles/PMC7892733/",
    "https://www.ncbi.nlm.nih.gov/pubmed/27117852",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4744393/",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7892733/#Sec20title",
    "https://fdc.nal.usda.gov/fdc-app.html#/food-details/171727/nutrients",
    "https://www.sciencedirect.com/science/article/pii/S1756464614002400",
    "https://pubmed.ncbi.nlm.nih.gov/22129334/",
    "https://pubmed.ncbi.nlm.nih.gov/28198157/",
    "https://www.ncbi.nlm.nih.gov/pubmed/18356331",
    "https://www.ncbi.nlm.nih.gov/pubmed/27207147",
    "https://www.webmd.com/diet/health-benefits-thyme#:~:text=Thyme%20may%20help%20with%3A,well%20as%20in%20the%20kitchen",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3706886/",
    "https://www.medicalnewstoday.com/what_is_bromelain_good_for/article.htm#:~:text=Chronic%20sinusitis%20(chronic%20rhinosinusitis),n%20as%20substitute%20for%20conventional%20chemotherapy"
];



export const icons = [
    {
        src: Gmp,
        alt: "GMP Certified",
    },
    {
        src: Fda,
        alt: "FDA Approved",
    },
    {
        src: Gmo,
        alt: "GMO Free",

    },
    {
        src: Nat,
        alt: "Natural Ingredients",

    },
    {
        src: Usa,
        alt: "USA Manufactured",
    },
];